<template>
  <div class="sr_box_slim" @click="clickOutside">
    <div class="flex-sp-container pt-2 pr-2 pl-2">
      <div
        v-if="propObj.mode < 1"
        class="sr_bold flex-container"
        :style="dynamicStyle"
      >
        <div>{{ propObj.targa }}</div>

        <div v-if="propObj.speed > 0" class="truck_spinner">
          <div class="rect1"></div>
          <div class="rect2"></div>
          <div class="rect3"></div>
          <div class="rect4"></div>
          <div class="rect5"></div>
        </div>
        <div class="tooltip" v-if="propObj.km > 0 || propObj.mn > 0">
          km {{ propObj.km }} in {{ minToString(propObj.mn) }}
          <span class="tooltiptext">Viaggio in corso</span>
        </div>
        <div class="id_style" @click.stop="setEditId">
          <div v-if="!id_edit">
            {{ propObj.vehicle_id ? propObj.vehicle_id : '----' }}
          </div>
          <div v-else>
            <input
              ref="inp1"
              class="input_style"
              type="text"
              v-click-outside="doStuff"
              v-model="propObj.vehicle_id"
              @click.stop="stopTheEvent"
              @keypress.enter="trigger()"
            />
          </div>
        </div>
      </div>
      <div
        v-if="propObj.mode > 0"
        class="sr_bold flex-container"
        :style="dynamicStyle"
      >
        <div>{{ propObj.targa }}</div>
        <div class="pr-1">
          <figure class="image is-16x16 is-center pl-1">
            <img title="Parking" src="images/park.png" />
          </figure>
        </div>
        <div class="tooltip" v-if="propObj.km > 0">
          km {{ propObj.km }} in {{ minToString(propObj.mn) }}
          <span class="tooltiptext">Viaggio in corso</span>
        </div>
        <div class="id_style" @click.stop="setEditId">
          <div v-if="!id_edit">
            {{ propObj.vehicle_id ? propObj.vehicle_id : '----' }}
          </div>
          <div v-else>
            <input
              ref="inp2"
              class="input_style"
              type="text"
              v-click-outside="doStuff"
              v-model="propObj.vehicle_id"
              @click.stop="stopTheEvent"
              @keypress.enter="trigger()"
            />
          </div>
        </div>
      </div>
      <div v-if="propObj.cod === selectedCod" class="flex-container">
        <span class="button is-info is-tiny" @click="goHistory">STORICO</span>
      </div>
      <div v-else class="flex-container">
        {{ calcSondaString(propObj) }}
      </div>
    </div>
    <div class="flex-sp-container pt-2 pr-2 pl-2">
      <div>
        {{ propObj.date | date_reverse_filter }}
      </div>
      <div>Km/h&nbsp;{{ propObj.speed }}</div>
    </div>
    <div
      class="truncate sr_small pt-2 pr-2 pl-2"
      :title="propObj.address | pipe_filter"
    >
      <span v-if="propObj.oscurata">---</span>
      <span v-else>{{ propObj.address | pipe_filter }}</span>
    </div>
    <div class="flex-sp-container p-2">
      <span class="sr_pausa_guida" v-if="propObj.km < 1 && propObj.mn < 1">{{
        calcPausaGuida(propObj.time, propObj.mode)
      }}</span>
      <div
        class="sr_pausa_guida is-pulled-right handcursor driverNote"
        @click="goChoice()"
      >
        {{ getDriverName(propObj) }}
      </div>
    </div>

    <div
      class="box p-2"
      v-if="choice != 0 || (driver_log && driver_log.note_log.length > 0)"
    >
      <div v-if="choice == 2">
        <div class="control">
          <textarea
            v-model="driver_log.note_log"
            class="textarea is-small driverNote"
            placeholder=""
          />
        </div>
        <div class="position_box">
          <button
            class="button is-pretty_small is-pulled-left is-danger"
            @click="goCancel()"
          >
            Annulla
          </button>
          <button
            class="button is-pretty_small is-pulled-right is-success"
            @click="goSave()"
          >
            Registra
          </button>
        </div>
      </div>
      <div
        v-if="choice != 2 && driver_log && driver_log.note_log.length > 0"
        class="driverNote"
      >
        {{ driver_log.note_log }}
      </div>
      <div class="position_box" v-if="choice == 1">
        <button
          class="button is-pretty_small is-pulled-left is-warning"
          @click="goEdit"
        >
          <span v-if="driver_log && driver_log.note_log.length > 0">
            Modifica
          </span>
          <span v-else> Inserisci </span>
        </button>
        <button
          class="button is-pretty_small is-pulled-right is-link"
          @click="goDriver"
        >
          Scheda
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { ServiceBus } from '../../ServiceBus.js'
import { UtilityMixin } from '../../mixins/UtilityMixin.js'
export default {
  name: 'PositionBox',
  mixins: [UtilityMixin],
  props: {
    propObj: {
      default: null,
      type: Object,
    },
    selectedCod: {
      default: '',
      type: String,
    },
    codUser: {
      default: '',
      type: String,
    },
    token: {
      default: '',
      type: String,
    },
    api_server: {
      default: '',
      type: String,
    },
    isLast: {
      default: false,
      type: Boolean,
    },
  },
  mounted() {
    const vm = this
    if (vm.propObj.id_driver) {
      vm.doGetLogDriverNote()
    }
  },
  data() {
    return {
      choice: 0,
      driver_log: null,
      prefs: null,
      auth: null,
      id_edit: false,
    }
  },
  created() {
    const vm = this
    vm.prefs = JSON.parse(vm.$localStorage.get('prefs'))
    vm.auth = JSON.parse(vm.$localStorage.get('auth'))
  },
  computed: {
    dynamicStyle() {
      const vm = this
      let choosenColor
      let s_mode = '' + this.propObj.mode
      if (this.propObj.mode >= 3 && this.propObj.mode < 24) {
        s_mode = '3'
      }
      switch (s_mode) {
        case '0':
          choosenColor = vm.prefs.bcg0
          break
        case '1':
          choosenColor = vm.prefs.bcg1
          break
        case '2':
          choosenColor = vm.prefs.bcg2
          break
        case '3':
          choosenColor = vm.prefs.bcg3
          break
        default:
          choosenColor = vm.prefs.bcg4
          break
      }
      return {
        color: choosenColor,
      }
    },
  },

  methods: {
    doStuff() {
      const vm = this
      vm.id_edit = false
    },
    setEditId() {
      const vm = this
      vm.id_edit = !vm.id_edit
      if (vm.id_edit) {
        if (vm.propObj.mode > 0) {
          this.$nextTick(() => {
            vm.$refs['inp2'].focus()
          })
        } else {
          this.$nextTick(() => {
            vm.$refs['inp1'].focus()
          })
        }
      }
    },
    clickOutside() {
      const vm = this
      if (vm.id_edit) {
        vm.trigger()
      }
    },
    async trigger() {
      const vm = this
      vm.id_edit = false
      await ServiceBus._doSaveVehicleID(vm.propObj.cod, vm.propObj.vehicle_id)
    },
    stopTheEvent(event) {
      event.stopPropagation()
    },
    goHistory() {
      const vm = this
      ServiceBus.$emit('showHistory', vm.propObj.cod)
    },
    goChoice() {
      const vm = this
      vm.choice = vm.choice >= 1 ? 0 : 1
      if (vm.isLast && vm.choice == 1) {
        setTimeout(() => {
          ServiceBus.$emit('showMore')
        }, 500)
      }
    },
    goEdit() {
      const vm = this
      this.choice = 2
      setTimeout(() => {
        ServiceBus.$emit('showMore')
      }, 500)
    },
    goCancel() {
      this.choice = 0
    },
    async goSave() {
      const vm = this
      await vm.doSave()
      this.choice = 0
    },
    goDriver() {
      this.$router.push({
        name: 'Drivers',
        params: { data: this.propObj.cod },
      })
    },
    getClass(obj) {
      const vm = this

      if (vm.propObj.couple.length === 0) {
        return 'sr_box_slim'
      }

      if (vm.propObj.targaKey.includes('|B|')) {
        return 'sr_box_slim sr_bord_rimorchio'
      } else {
        return 'sr_box_slim sr_bord_trattore'
      }
    },
    calcUM(s) {
      if (s == 'T') return '°'
      if (s == 'C') return 'L'
      return ''
    },
    calcSondaString(obj) {
      const vm = this
      let s = ''
      let sep = ''
      let um = ''
      if (obj.sonda_1.length > 0) {
        s =
          s +
          obj.sonda_1 +
          ' ' +
          vm.$options.filters.sondenull_filter(obj.v1) +
          vm.calcUM(obj.sonda_1)
        sep = ' - '
      }
      if (obj.sonda_2.length > 0) {
        s =
          s +
          sep +
          obj.sonda_2 +
          ' ' +
          vm.$options.filters.sondenull_filter(obj.v2) +
          vm.calcUM(obj.sonda_2)
        sep = ' - '
      }
      if (obj.sonda_3.length > 0) {
        if (obj.sonda_1 == 'T') {
          um = '°'
        }
        s =
          s +
          sep +
          obj.sonda_3 +
          ' ' +
          vm.$options.filters.sondenull_filter(obj.v3) +
          vm.calcUM(obj.sonda_3)
        sep = ' - '
      }
      if (obj.sonda_4.length > 0) {
        s =
          s +
          sep +
          obj.sonda_4 +
          ' ' +
          vm.$options.filters.sondenull_filter(obj.v4) +
          vm.calcUM(obj.sonda_4)
      }
      return s
    },
    async doSave() {
      const vm = this
      const response = await axios.post(
        vm.api_server + 'update_log_driver_note',
        {
          id: vm.driver_log.id,
          note_log: vm.driver_log.note_log,
        },
        {
          headers: {
            Authorization: vm.token,
          },
        }
      )
    },

    async doGetLogDriverNote() {
      const vm = this
      vm.driver_log = {}
      vm.driver_log.note_log = ''
      try {
        const response = await axios.get(
          vm.api_server + 'get_log_driver_note/' + vm.propObj.id_driver,
          {
            headers: {
              Authorization: vm.token,
            },
          }
        )
        if (vm.checkTkn(response.data)) {
          vm.driver_log = response.data[0]
        }
      } catch (e) {
        console.log('error ' + e)
      }
    },
  },
}
</script>
<style scoped>
.id_style {
  font-size: 9px;
  color: black;
  cursor: pointer;
}
.input_style {
  font-size: 9px;
  color: black;
}

.tooltip {
  position: relative;
  display: inline-block;
  font-size: 10px;
  color: black;
  padding-right: 3px;
  cursor: default;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip .tooltiptext::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
</style>

// :class="[propObj.codUser !== codUser ? 'sr_bord_coral' : '', 'sr_box_slim']"
